import { baseApi, select } from './base';
import { gql } from 'graphql-request';

import {
  analyticsNominationsTotalType,
  productType,
  analyticsNominationsDetailType,
} from '../graphqlTypes';

const analyticsProjectsValueTotalType = `
{
  manufacturer_id
  total_cost
  total_percentage
}
`;

const projectApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAnalyticsNominationsTotal: select(
      builder,
      'analytics_nominations_total',
      analyticsNominationsTotalType,
      false,
      {
        filter: (params) => {
          return `{ manufacturer_id: { _eq: ${params.userId} }}`;
        },
      },
      {
        providesTags: ['AnalyticsNominationsTotal'],
      }
    ),
    getManufacturerItems: select(builder, 'product', productType, false, {
      filter: (params) => {
        return `{ 
            manufacturer_id: { _eq: ${params.userId} },
            item: { _is_null: false, _neq: "" }
          }`;
      },
    }),
    getAnalyticsNominationsDetail: select(
      builder,
      'analytics_nominations_detail',
      analyticsNominationsDetailType,
      false,
      {
        filter: (params) => {
          return `{ manufacturer_id: { _eq: ${params.userId} }}`;
        },
      },
      {
        providesTags: ['AnalyticsNominationsDetail'],
      }
    ),
    getAnalyticsProjectsValueTotal: builder.query({
      query: (params) => ({
        body: gql`
        query {
          analytics_projects_value_total(args: {manuf_id: ${params.manufacturerId}}) ${analyticsProjectsValueTotalType}
        }
        `,
      }),
      transformResponse: (response) => response.analytics_projects_value_total,
      providesTags: ['AnalyticsProjectsValue'],
    }),
    getAnalyticsNominationsFiltered: builder.query({
      query: (params) => {
        // Create the where clause based on provided params
        let whereClause = [];

        // Add manufacturer filter if provided
        if (params.manufacturerId) {
          whereClause.push(`{ manufacturer_id: { _eq: ${params.manufacturerId} } }`);
        }

        // Add codes filter if provided
        if (params.codes && params.codes.length > 0) {
          const codesFilter = params.codes
            .map((code) => {
              const prefix = code.substring(0, 5); // Get first 5 chars (3 letters + hyphen + 1 digit)
              return `{ sheet_row_code: { _similar: "${prefix}%" } }`;
            })
            .join(',');
          whereClause.push(`{ _or: [${codesFilter}] }`);
        }

        // Combine filters with _and if both are present, otherwise use the single filter
        const finalWhereClause =
          whereClause.length > 1 ? `{ _and: [${whereClause.join(',')}] }` : whereClause[0] || '{}';

        return {
          body: gql`
          query {
            analytics_nominations_detail(
              where: ${finalWhereClause}
            ) ${analyticsNominationsDetailType}
          }
          `,
        };
      },
      transformResponse: (response) => response.analytics_nominations_detail,
      providesTags: ['AnalyticsNominationsDetail'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAnalyticsNominationsTotalQuery,
  useGetManufacturerItemsQuery,
  useGetAnalyticsNominationsDetailQuery,
  useGetAnalyticsProjectsValueTotalQuery,
  useGetAnalyticsNominationsFilteredQuery,
} = projectApi;
